/*
  Old section links keep working (Ed, 2026-10-18). Shopify names each section
  "shopify-section-template--<template number>__<section>", and the template number changes when
  the theme is published again, so a saved link such as
  /products/unbreakable-bootlaces#shopify-section-template--21658606862644__fe67931a-...
  stops finding its section. This finds the section by its own name and scrolls to it.
  The short link /products/unbreakable-bootlaces#vid goes to the videos directly.
*/
(function () {
  var id = '';
  try {
    id = decodeURIComponent(location.hash.slice(1));
  } catch (e) {
    return;
  }
  var m = id.match(/^shopify-section-template--\d+__(.+)$/);
  if (!m || document.getElementById(id)) return;
  var name = '__' + m[1];
  var el = Array.prototype.filter.call(document.querySelectorAll('[id^="shopify-section-template--"]'), function (s) {
    return s.id.slice(-name.length) === name;
  })[0];
  if (!el) return;
  el.scrollIntoView();
  // photos above it can still be loading and push it down; land again once the page has loaded,
  // unless the visitor has scrolled away meanwhile
  var y = window.scrollY;
  window.addEventListener('load', function () {
    if (Math.abs(window.scrollY - y) < 5) el.scrollIntoView();
  }, { once: true });
})();
